module.exports = __webpack_public_path__ + "img/deposit.4a887cea.png";